<template>
  <footer class="footer">
    <div class="footer__container container grid">
      <span class="footer__copy">
        Copyright &#169; {{ dateToday }} • Loic Farel
      </span>
    </div>
  </footer>
</template>
<script>
export default {
  computed: {
    dateToday() {
      let d = new Date();
      let y = d.getFullYear();
      return y;
    },
  },
};
</script>
<style scoped>
.footer {
  margin-top: 2rem;
  margin-bottom: 7rem;
}

.footer__container {
  padding: 8px 0;
}

.footer__copy {
  display: block;
  margin-top: 0.5rem;
  color: var(--text-color);
  text-align: center;
  font-size: var(--smaller-font-size);
}
</style>
